import { css, Stack, StackProps, styled } from '@mui/material'
import { Button } from 'components/common/Button'
import { unifiedColors } from 'styles/colors'
import { themeUtils } from 'styles/theme'

export const OptionsContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== '$fullWidth'
})<{ $fullWidth?: boolean }>`
  position: absolute;
  overflow: hidden;
  width: 280px;
  background: ${unifiedColors.surface.default};
  border: 2px solid ${unifiedColors.border.default};
  box-shadow: 2px 3px 0px 0px ${unifiedColors.shadow.quaternary};
  border-radius: 16px;
  top: 4px;
  right: 0;
  z-index: 1301;
  ${themeUtils.minWidth.md} {
    max-height: 300px;
    overflow-y: auto;
  }
  ${themeUtils.maxWidth.md} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid ${unifiedColors.border.accent};
    border-radius: 24px;
    background-color: ${unifiedColors.surface.subdued};
    box-shadow: 2px 3px 0px 0px ${unifiedColors.shadow.accent};
    overflow: hidden;
    width: 85vw;
  }
  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      ${themeUtils.minWidth.md} {
        left: 0;
        width: auto;
      }
    `}
`

export const Option = styled((props: StackProps) => (
  <Stack
    px={2.5}
    py={3}
    flexDirection="row"
    gap={1.5}
    {...props}
    alignItems="center"
  />
))`
  cursor: pointer;
  &:hover {
    background-color: ${unifiedColors.surface.secondary};
  }
`

export const StyledButton = styled(Button)`
  ${themeUtils.minWidth.md} {
    white-space: nowrap;
  }
  justify-content: ${({ fullWidth }) =>
    fullWidth ? 'space-between' : 'center'};
`
